import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export const isCurrentUserTheMailSender = (emailSender: EmailAddressWrapper) => {
    const userEmailAddress = getUserConfiguration()?.SessionSettings?.UserEmailAddress;
    return !!userEmailAddress && userEmailAddress === emailSender?.EmailAddress;
};
